module.exports = "<div (click)=\"togglePanels()\">{{ label }}</div>\n"